import { Component, OnInit } from '@angular/core';
import { LocalStorageService } from 'angular-2-local-storage';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
Role:string = "";
CurrentYear:number;
  constructor(private Localstorage: LocalStorageService) { 
    this.CurrentYear = new Date().getFullYear();
  }

  ngOnInit(): void {
    this.Role = this.Localstorage.get("UserRole");
  }

}
